(function initHomeInfoAccordions(root = document) {
  const detailsList = root.querySelectorAll(".home-info details");

  detailsList.forEach((detail) => {
    const summary = detail.querySelector("summary");
    const content = detail.querySelector(".home-info-content");
    if (!summary || !content) return;
    if (detail.open) {
      content.style.maxHeight = "none";
      content.style.opacity = "1";
    } else {
      content.style.maxHeight = "0px";
      content.style.opacity = "0";
    }
    const onTransitionEndOnce = (cb) => {
      const handler = (e) => {
        if (e.propertyName !== "max-height") return;
        content.removeEventListener("transitionend", handler);
        cb();
      };
      content.addEventListener("transitionend", handler);
    };
    summary.addEventListener("click", (e) => {
      e.preventDefault();
      if (detail.dataset.animating) return;
      detail.dataset.animating = "1";

      if (detail.open) {
        const startHeight = content.scrollHeight;
        content.style.maxHeight = startHeight + "px";
        requestAnimationFrame(() => {
          content.style.maxHeight = "0px";
          content.style.opacity = "0";
        });
        onTransitionEndOnce(() => {
          detail.open = false;
          content.style.maxHeight = ""; 
          delete detail.dataset.animating;
        });
      } else {
        detail.open = true;
        const targetHeight = content.scrollHeight;
        content.style.maxHeight = "0px";
        content.style.opacity = "1";
        requestAnimationFrame(() => {
          content.style.maxHeight = targetHeight + "px";
        });
        onTransitionEndOnce(() => {
          content.style.maxHeight = "none"; 
          delete detail.dataset.animating;
        });
      }
    });
  });
})();

document.addEventListener("shopify:section:load", (e) => {
  if (e.target) {
    (function init(root) {
      const script = document.currentScript;
      (function initHomeInfoAccordions(rootEl = root) {
        const detailsList = rootEl.querySelectorAll(".home-info details");
        detailsList.forEach((d) => {
          if (!d.dataset.bound) d.dataset.bound = "0";
        });
      })(root);
    })(e.target);
  }
});